<template lang="pug">
  main.about#main
    .hero
      img.hero-image(:src='hero_image.url', :alt='hero_image.alt')
      .hero-text-wrapper
        prismic-rich-text(:field='hero_title')
        prismic-rich-text(:field='hero_description')

    .content-wrapper
      prismic-rich-text(:field='text_only')

    .v-column(v-for="(item, index) in text_and_media", :key="index")
      .panel(:class="'image-' + item.image_placement_selection")
        .image-wrapper
          prismic-image(:field='item.image')
        .text-wrapper
          prismic-rich-text(:field='item.subtitle')
          prismic-rich-text(:field='item.text_content')
</template>

<script>
  export default {
    name: 'about',
    data () {
      return {
        hero_title: null, 
        hero_description: null, 
        hero_image: '',
        text_only: null, 
        text_and_media: null,
        metadata: {
          title: null, 
          description: null, 
          socialTitle: null, 
          socialDescription: null, 
          socialImage: null
        }
      }
    }, 
    metaInfo () {
      return {
        title: this.metadata.title, 
        titleTemplate: '%s- Progressive Plant Research',
        meta: [
          { name: 'description', content: this.metadata.description },
          { property: 'og:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
          { property: 'og:description', content: this.metadata.socialDescription },
          { property: 'og:image', content: this.metadata.socialImage },
          { name: 'twitter:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
          { name: 'twitter:description', content: this.metadata.socialDescription },
          { name: 'twitter:image', content: this.metadata.socialImage }
        ],
      }
    }, 
    methods: { 
      getContent (uid) {
        this.$prismic.client.getByUID('about', 'about').then((document) => {
          if (document) {
            this.hero_title = document.data.hero_title
            this.hero_description = document.data.hero_description
            this.hero_image = document.data.hero_image
            this.text_only = document.data.text_only
            this.text_and_media = document.data.text_and_media
            //  metadata
            this.metadata.title = document.data.metadata_title;
            this.metadata.description = document.data.metadata_description;
            this.metadata.socialTitle = document.data.metadata_social_title;
            this.metadata.socialDescription = document.data.metadata_social_description;
            this.metadata.socialImage = document.data.metadata_social_image;
          } else {
            this.$router.push({ name: 'not-found' })
          }
        });
      }, 
    },
    created () {
      this.getContent(this.$route.params.uid)
    },
    beforeRouteUpdate (to, from, next) {
      this.getContent(to.params.uid)
      next()
    }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/components/hero.styl'

// paragraph reset
p 
  margin 0
  line-height 1.8

.content-wrapper
  width 65%
  margin 7em auto

.v-column 
  width 65%
  margin 7em auto

  .panel
    display flex
    justify-content space-between
    align-items center

  .image-right
    flex-direction row-reverse 

  .image-wrapper 
    max-width 45%
    img
      width 100%
      
  .text-wrapper 
    max-width 45%
    display flex 
    flex-direction column
    justify-content flex-start
    div:first-child
      margin-bottom 2rem
      align-self center

      h2
        font-size 2.3rem
        line-height 3rem
        margin 0


@media (max-width: 768px)
  .content-wrapper
    width 85%
    margin 4em auto

  .v-column
    width 85%
    grid-template-columns 1fr
    margin 4em auto


</style>